/* @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'

import { CustomerLogoBanner } from '@slite/components'

import { Button } from '../../components/Button/Button'
import { Section } from '../../components/Section'
import { WebsiteText } from '../../components/WebsiteText'
import { useRoutes } from '../../routes'
import { SMALL_BREAKPOINT } from '../../utils/breakpoints'
import { AnimatingCompanies } from './AnimatingCompanies'
import { McpVisual } from './McpVisual'

export function SectionMcpHero() {
  const routes = useRoutes()

  return (
    <Section
      isFirstSection
      containerTopPadding={80}
      containerBottomPadding={80}
      background="moon-dust-lighter"
      className="position-relative"
    >
      <div
        className={classNames(
          'flexbox flexbox-column flexbox-align-center text-align-center',
          'margin-left-auto margin-right-auto'
        )}
        style={{ maxWidth: 900 }}
      >
        <WebsiteText
          variant="heroTitle"
          className="text-align-center position-relative"
          css={css`
            && {
              font-size: 64px;
              max-width: 900px;
              margin-left: auto;
              margin-right: auto;
              line-height: 1.2;

              @media (max-width: ${SMALL_BREAKPOINT - 1}px) {
                font-size: var(--font-size-1);
              }
            }
          `}
        >
          <FormattedMessage
            id="mcp.title"
            defaultMessage="Give {clients} the keys to your company knowledge"
            values={{
              clients: (
                <>
                  <span className="sr-only">
                    <FormattedMessage
                      id="mcp.title.clients"
                      defaultMessage="Claude, ChatGPT, Cursor, and any AI agent"
                    />
                  </span>
                  <AnimatingCompanies />
                </>
              ),
            }}
          />
        </WebsiteText>
        <p
          className="font-size-4 line-height-large margin-top-16 padding-top-24 shade-10"
          style={{ maxWidth: 600 }}
        >
          <FormattedMessage
            id="mcp.hero.subtitle"
            defaultMessage="Stop chaining 10 fragile, read-only connectors. Slite MCP exposes search in docs or connected sources and rich editing directly to Claude, Cursor, or your custom agent workflows."
          />
        </p>
        <div className="margin-top-32 flexbox flexbox-align-center flexbox-gap-12">
          <Button variant="primary" size="huge" href={routes.auth.signup()}>
            <FormattedMessage
              id="mcp.hero.cta.try"
              defaultMessage="Try Slite MCP"
            />
          </Button>
          <Button
            variant="ghost"
            size="huge"
            href={routes.external.mcpHelp.url}
          >
            <FormattedMessage
              id="mcp.hero.cta.doc"
              defaultMessage="See the docs"
            />
          </Button>
        </div>
      </div>

      <div
        css={css`
          @media (max-width: ${SMALL_BREAKPOINT - 1}px) {
            margin-top: 24px;
          }
        `}
      >
        <McpVisual />
      </div>

      <div className="padding-top-40">
        <p className="text-align-center font-size-4 line-height-large shade-10">
          <FormattedMessage
            id="mcp.hero.customer.caption"
            defaultMessage="1,700+ leading companies trust Slite as their single source of truth."
          />
        </p>
        <div
          className="margin-left-auto margin-right-auto"
          style={{ maxWidth: 900 }}
        >
          <CustomerLogoBanner />
        </div>
      </div>
    </Section>
  )
}
